<template>
	<v-container class="pa-0">
		<v-dialog width="500px" v-model="showEditGroup">
			<v-card>
				<v-card-title><v-icon>mdi-pencil</v-icon> Editar Grupo</v-card-title>
				<v-card-text>
					<v-img  v-if="grupo.imagem_grupo" width="100px" contain height="auto"  class=" mx-auto rounded-sm"
                :src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
				<h3><v-icon small>mdi-pencil</v-icon> Nome do Grupo</h3>
				<v-text-field color="#F15A24" v-model="edit.nome_grupo"></v-text-field>

				<h3><v-icon small>mdi-image</v-icon> Imagem </h3>

				<v-file-input color="#F15A24" v-model="edit.imagem_grupo" label="Alterar Imagem"></v-file-input>

				<h3 v-if="user.plano === `plano-premium`"><v-icon small>mdi-lock</v-icon> Restrito</h3>
				<v-checkbox v-if="user.plano === `plano-premium`" color="#F15A24" v-model="edit.restrito"
					label="Grupo Restrito (participantes não podem exportar conteúdos do grupo)" />
				</v-card-text>
				<v-card-actions class="d-flex justify-end">
					<v-btn text @click="showEditGroup=false"> Cancelar</v-btn>
					<v-btn :#loading="loadingEdit" color="#F15A24" dark
						@click="updateGroup">
							<v-icon>mdi-check</v-icon>
						Salvar Grupo</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row class="mt-3">
			<v-col class="mt-0 pt-0 d-flex align-center justify-space-between" cols="12" lg="9">
			
				<h3 class="d-flex flex-row align-center my-orange" >
					<v-img  v-if="grupo.imagem_grupo" width="100px" contain height="auto"  class="rounded-sm mr-5"
                :src="`https://api.mylegis.com.br/assets/${grupo.imagem_grupo}`" />
					{{ grupo.nome_grupo }}
					<v-btn outlined x-small class="ml-5" v-if="isOwner" @click="edit.nome_grupo=grupo.nome_grupo;showEditGroup=true">
						<v-icon small>mdi-pencil</v-icon>Editar
					</v-btn>
				</h3>
				
				<v-btn text @click="reloadGrupo"><v-icon color="black">mdi-refresh</v-icon> Atualizar</v-btn>

			</v-col>
			<v-col class="text-center" cols="12" lg="3">
				<DialogConfirm
				:titulo="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
				icon="mdi-delete-outline"
				:texto="`Você tem certeza que deseja ${isOwner ? `oxcluir o` : `sair do`} grupo ${grupo.nome_grupo}`"
				:botao="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
				:confirmado="excluirGrupo"
				>
				</DialogConfirm>
				<BtnAdicionarGrupo class="mt-2" v-if="isAdmin" :reload-integrantes="reloadGrupo" :id-grupo="grupo.id"
					:integrantes="grupo.integrantes"></BtnAdicionarGrupo>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" lg="9">
				<h2>Feed do Grupo</h2>
				<v-row>
					<v-col v-if="anotacoes.length == 0 && !loadingFeed" cols="12">
						<p class="mt-5">
							Ainda não existe conteúdo por aqui. Faça anotações e conexões para
							alimentar o seu feed.
						</p>
					</v-col>
					<v-col cols="12" class="text-center">
						<v-progress-circular v-if="loadingFeed" class="mx-auto" color="#F15A24"
							indeterminate></v-progress-circular>
					</v-col>
					<div style="width:100%" v-if="!loadingFeed">
						<v-col v-for="(annotation, i) in anotacoes" :key="i" cols="12">
							<v-card elevation="0" class="annotation mb-0">
								<v-card-title class="text-subtitle-1 mb-2" style="border-bottom:1px solid #efefef; ">
									<v-img max-width="30px" max-height="30px" class="rounded-circle mr-1"
										v-if="annotation.user_created.avatar" cover
										:src="`https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id}`" />
									<v-img max-width="25px" class="rounded-circle mr-1"
										v-if="!annotation.user_created.avatar" contain src="../assets/icon-person.svg" />

									{{
										annotation.user_created.first_name +
										" " +
										annotation.user_created.last_name
									}}
									em
									<router-link class="ml-2" style="color: #000" :to="'/painel/lei/' +
											annotation.id_lei.id_lei +
											'/' +
											sanitizeTitle(annotation.id_lei.numero_lei)
											">
										{{ annotation.id_lei.numero_lei }}
									</router-link>


								</v-card-title>
								<v-card-text class="annotationText">
                  <p class="reg mx-0 "> {{ annotation.id_reg.conteudo }} </p>

                  <p v-html="annotation.texto"></p>
                </v-card-text>								
								<v-card-actions class="d-flex flex-column align-end justify-end"
									style="border-bottom: 1px solid #efefef">
									<p class="d-flex align-end justify-end  mb-0">
										<v-btn text
											@click="importPost = { ...annotation }; showNewAnnotation = true"><v-icon
												small>mdi-import</v-icon> Importar post</v-btn>
												<v-btn text
											@click="importPost = { ...annotation, texto: `Escrito por ${annotation.user_created.first_name}:  ${annotation.texto}` }; showNewAnnotation = true"><v-icon
												small>mdi-comment-outline</v-icon> Responder</v-btn>
									</p>
									<small class="pr-4">
										<span v-if="annotation.status === `group`">
											<v-icon>mdi-account-group</v-icon>
											{{ annotation.id_grupo.nome_grupo }}
										</span>
										<span v-else>
											<v-icon small>{{
												annotation.status === `private`
												? `mdi-lock`
												: `mdi-earth`
											}}</v-icon>
											{{ annotation.status | filterStatus }}
										</span>
										-
										<v-icon small>mdi-clock-outline</v-icon>
										{{ annotation.date_updated === null ? "Criado em" : "Atualizado em" }}
										{{ annotation.date_updated === null ? annotation.date_created :
											annotation.date_updated | brdatetime }}
									</small>

								</v-card-actions>
							</v-card>
						</v-col>
					</div>
				</v-row>
			</v-col>
			<v-col cols="12" lg="3">
				<v-row class="">
					<v-col cols="12"  class="pb-0">
						<h2 class="text-center">
							Administradores
						</h2>
					</v-col>
					<v-col cols="12">
						<v-list style="width:100%">
							<v-list-item   v-for="a in grupo.administradores" :key="a.directus_users_id.id">
								<v-list-item-avatar>
									<v-img max-width="40px" height="40px" class="rounded-circle" cover
								:src="a.directus_users_id.avatar ? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}` : require(`../assets/icon-person.svg`)" />
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title  class="d-flex text-subtitle-2 " style="white-space: inherit;">
										{{ a.directus_users_id.first_name }}
									{{
										a.directus_users_id.last_name !== null
										? a.directus_users_id.last_name
										: ""
									}}
									</v-list-item-title>
									<v-list-item-subtitle>
										<v-btn disabled x-small outlined v-if="isOwner & user.id == a.directus_users_id.id">
											Proprietário
										</v-btn>
										<v-btn  v-if="isOwner && user.id !== a.directus_users_id.id" @click="excluirAdmin(a.id)" class="pa-0" text x-small   style="cursor: pointer;" >
											<v-icon small >mdi-close</v-icon> Remover Administrador 
										</v-btn>
									</v-list-item-subtitle>
								</v-list-item-content>
								
							</v-list-item>
						</v-list>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="pb-0" cols="12">
						<h2 class="text-center">
							Integrantes
						</h2>
					</v-col>
					<v-col cols="12">
						<v-list>
							<v-hover v-slot="{ hover }"   v-for="a in integrantes" :key="a.directus_users_id.id"   v-show="!isInAdmin(a.directus_users_id.id)">

							<v-list-item >
								<v-list-item-avatar>
									<v-img max-width="40px" height="40px" class="rounded-circle" cover
									:src="a.directus_users_id.avatar ? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}` : require(`@/assets/icon-person.svg`)" />
								</v-list-item-avatar>
								<v-list-item-content class="d-flex flex-row">
									<v-list-item-title class="d-flex text-subtitle-2" style="white-space: inherit;">
										{{ a.directus_users_id.first_name }}
										{{
											a.directus_users_id.last_name !== null
											? a.directus_users_id.last_name
											: ""
										}}
									</v-list-item-title>
									<v-list-item-subtitle v-if="isAdmin && hover" @click="tornarAdmin(a.directus_users_id.id)">
										<v-btn x-small>
											<v-icon small >mdi-account-star-outline</v-icon>Tornar Administrador 
										</v-btn>
									</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action>
										<v-icon v-if="isAdmin" small @click="excluirIntegrante(a.id)">mdi-delete</v-icon><br>
										
									</v-list-item-action>
								</v-list-item>
								</v-hover>
						</v-list>

						
					</v-col>
				</v-row>

			</v-col>
		</v-row>
		<v-dialog width="700px" v-model="showNewAnnotation">
			<v-card class="px-5">
				<v-card-title class="px-0">Importar Anotação <v-spacer />
					<v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text>
					<h3></h3>
					<p class="pa-2" style="border: 1px dashed #f15a24">{{ importPost.id_lei.numero_lei }}</p>
					<p class=" mx-0 "> {{ importPost.id_reg.conteudo }} </p>

					<h3>Visibilidade</h3>
					<v-select color="#F15A24" :items="statusAnnotation" v-model="importPost.status"></v-select>
					<h3 v-if="importPost.status == `group`">Selecione o grupo</h3>
					<v-select v-if="importPost.status == `group`" item-text="grupos_id.nome_grupo" item-value="grupos_id.id"
						color="#F15A24" :items="groups" v-model="importPost.id_grupo.id"></v-select>
					<h3 class="d-flex">
						Conteúdo
					</h3>
					<VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
						:editor-toolbar="customToolbar" v-model="importPost.texto" />
				</v-card-text>
				<v-card-actions class="justify-end px-0">
					<v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
					<v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
						<v-icon class="ml-1" small>mdi-content-save</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
h2 {
	font-family: "Inter";
	font-weight:bold;
	color: #707070;
	text-align: left;
}

.annotation {
	border: 1px solid rgb(200 200 200) !important;
	margin: 8px 0px;
	border-radius: 10px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
	max-width: 100% !important;
}

.annotation ::v-deep iframe {
	height: 250px;
}

.annotationText div {
	width: 100%;

}

.reg {
  border: 1px dashed gray;
  border-radius: 10px;
  padding: 5px;
}
</style>

<script>
import BtnAdicionarGrupo from '../components/BtnAdicionarGrupo.vue';
import DialogConfirm from '../components/DialogConfirm.vue';
import { VueEditor } from "vue2-editor";

export default {
	components: { BtnAdicionarGrupo, VueEditor,DialogConfirm },
	data: () => ({
		edit: { },
		showEditGroup: false,
		loadingEdit: false,
		grupo: { administradores: [] },
		anotacoes: [],
		loadingFeed: false,
		integrantes: [],
		showNewAnnotation: false,
		loadingNewAnnotation: false,
		importPost: { id_lei: {}, id_reg: {} },
		statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [
          { header: "1" },
          { header: "2" },
          "blockquote",
          "code-block",
        ],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
	}),
	mounted() {
		this.reloadGrupo();
	},
	computed: {
		groups() {
			return this.$store.state.filteredGroups
		},
		isAdmin() {
			// return false
			return this.grupo.administradores.find(e => e.directus_users_id.id === this.$store.state.user.id)
		},
		isOwner() { 
			return this.grupo.user_created === this.$store.state.user.id
		},
		user() { 
			return this.$store.state.user
		}
	},
	methods: {
		async updateGroup() { 
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				nome_grupo: this.edit.nome_grupo
			})
			this.edit = { }
			this.loadingEdit = false
			this.showEditGroup = false
			this.reloadGrupo()
		},
		isInAdmin(id) {
			let eh = this.grupo.administradores.find(e => e.directus_users_id.id === id)
			return eh !== undefined
		},
		async excluirGrupo() {
			if (!this.isOwner) { 
				let integrante = this.grupo.integrantes.filter(e => e.directus_users_id.id === this.user.id)
				this.excluirIntegrante(integrante[0].id, true)
				return
			}
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				status: "archived"
			})
			this.$router.go(-1);
		},
		async tornarAdmin(id) { 
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: { create: [{ directus_users_id: { id: id}, grupos_id: this.$route.params.id_grupo }] }
			})
			this.reloadGrupo();
		},
		async excluirAdmin(id) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: { delete: [id] }
			})
			this.reloadGrupo();
		},
		async excluirIntegrante(id,admin) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				integrantes: { delete: [id] }
			})
			this.reloadGrupo();

			if (admin) this.$router.go(-1)
			
		},
		reloadGrupo() {
			this.$http
				.get("items/grupos/" +
					this.$route.params.id_grupo +
					"?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,*")
				.then((res) => {
					this.grupo = res.data.data;
					if (this.grupo.adminsitradores) {
						this.integrantes = this.grupo.integrantes.filter((el) => !this.grupo.administradores.find(e => e.directus_users_id.id === el.directus_users_id.id));
					}
					else this.integrantes = this.grupo.integrantes
					this.loadGroupsFeed();
				});
		},
		async loadGroupsFeed() {
			this.loadingFeed = true;
			this.anotacoes = []
			const query = `query MyGroup($group_id:String){
					anotacoes(
						filter: { id_grupo: { id: { _eq: $group_id}}}
					) {
						id
						date_created
						date_updated
						texto
						status
						user_created {
							first_name
							last_name
							id
							avatar { 
								id 
							}
						}
						id_grupo { 
							id
							nome_grupo
						}  
						id_lei {
							id_lei
							numero_lei
						}
						id_reg { 
							id_reg
							conteudo
						}
					}
				}`;
			const variables = {
				group_id: this.grupo.id,
			};
			const { data: { data }, } = await this.$http.post("/graphql", {
				query,
				variables,
			});
			this.anotacoes = this.anotacoes.concat(data.anotacoes);
			this.anotacoes.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
			this.loadingFeed = false;
		},
	handleImageAdded(file, Editor, cursorLocation) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("image", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // window.console.log(response);
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    saveNewAnnotation() {
      this.loadingNewAnnotation = true;
      let dt = {
        id_lei: this.importPost.id_lei,
        id_reg: this.importPost.id_reg,
        status: this.importPost.status,
        id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
        texto: this.importPost.texto,
      };
      this.$http
        .post("items/anotacoes", dt)
        .then((response) => {
          if (response.data.data.id != undefined) {
            // this.reloadAnotacoes();
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            // this.importPost = { status: "private" };
            this.importPost = { id_lei: {}, id_reg: {} },
              this.conteudoSelected = {};


            let conteudo = this.conteudos.find(
              (el) => el.id_reg === dt.id_reg
            );
            if (conteudo.anotacoes)
              conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch(() => {
          this.loadingNewAnnotation = false;
        });
    },
		sanitizeTitle: function (title) {
			var slug = "";
			// Change to lower case
			var titleLower = title.toLowerCase();
			// Letter "e"
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
			// Letter "a"
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
			// Letter "o"
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
			// Letter "u"
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
			// Letter "d"
			slug = slug.replace(/đ/gi, "d");
			// Trim the last whitespace
			slug = slug.replace(/\s*$/g, "");
			// Change whitespace to "-"
			slug = slug.replace(/\s+/g, "-");
			return slug;
		},
	},
};
</script>
